@if (store.serviceId()) {
    <div class="flex-column gap pb-3">
        <app-service-settings-common
            [settingsKey]="SERVICE_SETTINGS_SPECIALIST_RECORD_TYPE_KEY"
            [title]="'service.settings.specialistRecord.header'"
        ></app-service-settings-common>

        <div>
            <app-service-specialist-record-work-type-modal></app-service-specialist-record-work-type-modal>
            <app-card-table
                #specialistRecordWorkTypeTable
                [showDelete]="isAllowed['service.update']()"
                [showDetail]="isAllowed['service.update']()"
                [tableTitle]="'service.settings.specialistRecord.workType.label'"
                [columns]="workTypeColumns"
                translatePrefix="service.settings.specialistRecord.workType."
                [hideCheckboxes]="true"
                [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [store.serviceId()!.toString()] }]]"
                [gridData]="store.data.getServiceSpecialistRecordWorkTypes()"
                [refreshCallback]="store.api.getServiceSpecialistRecordWorkTypes"
                [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
                (deleteCallbackWithEvent)="deleteWorkType($event)"
                (createCallback)="createWorkType()"
                (detailCallback)="updateWorkType($event)"
            >
            </app-card-table>
        </div>

        <div>
            <app-service-specialist-record-contact-type-modal></app-service-specialist-record-contact-type-modal>
            <app-card-table
                #specialistRecordContactTypeTable
                [tableTitle]="'service.settings.specialistRecord.contactType.label'"
                [columns]="contactTypeColumns"
                translatePrefix="service.settings.specialistRecord.contactType."
                [hideCheckboxes]="true"
                [additionalFilter]="[[{ column: 'serviceId', operator: 'EQ', value: [store.serviceId()!.toString()] }]]"
                [gridData]="store.data.getServiceSpecialistRecordContactTypes()"
                [refreshCallback]="store.api.getServiceSpecialistRecordContactTypes"
                [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
                (deleteCallbackWithEvent)="deleteContactType($event)"
                (createCallback)="createContactType()"
                (detailCallback)="updateContactType($event)"
            >
            </app-card-table>
        </div>
    </div>
}
